import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  id: null,
};

const selectedIdSlice = createSlice({
  name: 'selectedId',
  initialState,
  reducers: {
    setSelectedId: (state, action) => ({ ...state, id: action.payload }),
    clearSelectedId: (state) => ({ ...state, id: null }),
  },
});

export const { setSelectedId, clearSelectedId } = selectedIdSlice.actions;

export const selectSelectedId = (state) => state.selectedId?.id;

export default selectedIdSlice.reducer;
